/*
 * Encabezado de Colchones Fantasía.
 *
 * - Buscador: mientras está vacío y sin el cursor, el texto de ayuda escribe y borra solo las
 *   sugerencias del editor del tema (Configuración del tema › Colchones Fantasía › Buscador).
 *   Sin animación si el sistema pide «reducir movimiento».
 * - Al bajar por la página, el encabezado toma una sombra suave (clase en <html>).
 */
(() => {
  const ajustes = window.fantasiaBusqueda || {};
  const prefijo = ajustes.prefijo || '';
  const textos = (ajustes.textos || []).map((t) => String(t).trim()).filter(Boolean);
  const reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const animarBuscador = (input) => {
    if (input.dataset.fantasiaEscribe) return;
    input.dataset.fantasiaEscribe = '1';

    if (textos.length === 0) return;
    if (reducir) {
      input.placeholder = `${prefijo}${textos[0]}…`;
      return;
    }

    let indice = 0;
    let letras = 0;
    let borrando = false;

    const paso = () => {
      // Quieto mientras el cliente escribe o tiene el cursor en el buscador.
      if (document.activeElement === input || input.value !== '') {
        input.placeholder = `${prefijo}${textos[indice]}…`;
        setTimeout(paso, 600);
        return;
      }

      const texto = textos[indice];
      letras += borrando ? -1 : 1;
      input.placeholder = `${prefijo}${texto.slice(0, letras)}${letras === texto.length ? '…' : ''}`;

      let espera = borrando ? 35 : 75;
      if (!borrando && letras === texto.length) {
        borrando = true;
        espera = 1800;
      } else if (borrando && letras === 0) {
        borrando = false;
        indice = (indice + 1) % textos.length;
        espera = 350;
      }
      setTimeout(paso, espera);
    };

    input.placeholder = prefijo;
    setTimeout(paso, 800);
  };

  const iniciar = () => {
    document.querySelectorAll('.header__search input[name="q"], .search-modal input[name="q"], .search-drawer__form input[name="q"]').forEach(animarBuscador);
  };

  const sombra = () => document.documentElement.classList.toggle('fantasia-desplazado', window.scrollY > 8);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  window.addEventListener('scroll', sombra, { passive: true });
  sombra();
  // Buscador del celular (se abre en una ventana) y cambios en el editor del tema.
  document.addEventListener('click', () => setTimeout(iniciar, 50));
  document.addEventListener('shopify:section:load', iniciar);
})();
